<template>
  <div>
    <div class="table_th">
      <div style="width:15%">
        {{ $t(`lang.str_bet`) }}
      </div>
      <div style="width:30%">
        {{ $t(`lang.str_jump_height`) }}
      </div>
      <div style="width:30%">
        {{ $t(`lang.str_jump_amount`) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:15%">
        <div>{{ bet_amount }}</div>
      </div>
      <div style="width:30%">
        <div>{{ balloon_size }}x</div>
      </div>
      <div style="width:30%">
        <div> {{ balloon_result }}</div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3002",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    bet_amount:0,
    balloon_size:0,
    balloon_result:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3002.vue